/**
 * <sky-newsletter-popup> — theme-wide newsletter popup.
 * Shows after data-delay seconds, at most once per data-frequency days (localStorage).
 * In the theme editor it always previews (no persistence) so the merchant can see it.
 */
const KEY = 'sky_nlp_dismissed';

class SkyNewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.delay = (parseFloat(this.dataset.delay) || 0) * 1000;
    this.freq = parseFloat(this.dataset.frequency) || 0;
    this.design = document.documentElement.classList.contains('shopify-design-mode');

    // If the form was just submitted successfully, keep it open to show the message.
    const posted = /[?&]customer_posted=true/.test(location.search) || this.querySelector('.sky-form-msg--success');
    if (posted) {
      this.open();
      this.mark();
    } else if (this.shouldShow()) {
      this.timer = setTimeout(() => this.open(), this.delay);
    }

    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-nlp-close]')) this.close();
    });
    this._onKey = (e) => {
      if (e.key === 'Escape') this.close();
    };

    // A successful sign-up marks it dismissed for good-ish and closes shortly after.
    this.addEventListener('submit', () => {
      this.mark();
    });
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    document.removeEventListener('keydown', this._onKey);
  }

  shouldShow() {
    if (this.design) return true; // always preview in the editor
    try {
      const until = parseFloat(localStorage.getItem(KEY) || '0');
      if (until && Date.now() < until) return false;
    } catch (e) {}
    return true;
  }

  mark() {
    if (this.design) return;
    try {
      const days = this.freq > 0 ? this.freq : 0;
      const until = days > 0 ? Date.now() + days * 86400000 : Date.now() + 86400000; // min 1 day
      localStorage.setItem(KEY, String(until));
    } catch (e) {}
  }

  open() {
    if (this.hasAttribute('data-open')) return;
    this.hidden = false;
    this.setAttribute('data-open', '');
    // next frame so the transition runs
    requestAnimationFrame(() => this.classList.add('is-open'));
    document.addEventListener('keydown', this._onKey);
    const field = this.querySelector('input[type="email"]');
    if (field && !this.querySelector('.sky-form-msg--success')) {
      setTimeout(() => field.focus({ preventScroll: true }), 350);
    }
  }

  close() {
    this.classList.remove('is-open');
    this.removeAttribute('data-open');
    document.removeEventListener('keydown', this._onKey);
    this.mark();
    setTimeout(() => {
      this.hidden = true;
    }, 350);
  }
}

if (!customElements.get('sky-newsletter-popup')) {
  customElements.define('sky-newsletter-popup', SkyNewsletterPopup);
}
